import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { connect, useSelector } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { setCustomerDetails } from "../../redux/actions/customerAction";
import HttpService from "../../services/httpService";

const CustomerHoldReqPage = (props) => {
  const { customerDetails } = useSelector((state) => state.customer);

  const formatDateForInput = (date) => {
    if (!date) return "";
    try {
      return new Date(date).toISOString().split("T")[0];
    } catch {
      return "";
    }
  };

  const [formData, setFormData] = useState({
    customerName: "",
    customerEmail: "",
    followUpDate: "",
    workStartDate: "",
    workEndDate: "",
    reasonForHold: "",
    customerResumeDate: "",
    customerRemarks: "",
    rejectReason: "",
    initiationIsHold: false,
  });

  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);

  useEffect(() => {
    if (!customerDetails) return;

    setFormData((prev) => ({
      ...prev,
      customerName: customerDetails?.name || "",
      customerEmail: customerDetails?.email || "",
      followUpDate: formatDateForInput(customerDetails?.initiationFollowUpDate),
      workStartDate: formatDateForInput(customerDetails?.initiationTentativeWorkStartDate),
      workEndDate: formatDateForInput(customerDetails?.initiationTentativeWorkEndDate),
      initiationIsHold: formatDateForInput(customerDetails?.initiationIsHold),
      reasonForHold: customerDetails?.initiationHoldReason || "",
    }));
  }, [customerDetails]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const initiationBomTableOps = async (action) => {
    props.setLoading(true);
    try {
      const payload = {
        selectedAction: action,
        formData,
        leadId: customerDetails?.leadId,
      };

      const response = await HttpService.initiationBomTableOps(payload);

      if (!response?.data?.success) {
        props.setSnackInfo(response?.data?.message || "Operation failed", "error");
        return;
      }

      props.setSnackInfo(response?.data?.message || "Success", "success");
    } catch (err) {
      props.setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      props.setLoading(false);
      setApproveDialogOpen(false);
      setRejectDialogOpen(false);
    }
  };

  const isApproveSubmitEnabled =
    formData.customerResumeDate && formData.customerRemarks;

  const isRejectSubmitEnabled = formData.rejectReason;

  return (
    <Box display="flex" justifyContent="center" padding={2} minHeight="100vh" bgcolor="#f5f6fa">
      <Card style={{ width: "100%", maxWidth: 550, margin: "160px 0" }}>
        <CardContent>
          <Box textAlign="center" mb={3}>
            <img
              src="https://www.decorpot.com/images/bannerImg/decorpot-home-interiors-logo-image.png"
              alt="Decorpot Logo"
              style={{ height: 80 }}
            />
            <Typography variant="h6" style={{ marginTop: 10 }}>
              Initiation BOM Hold Approval Request Form
            </Typography>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField label="Customer Name" fullWidth value={formData.customerName} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Customer Email" fullWidth value={formData.customerEmail} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Follow-Up Date" type="date" fullWidth value={formData.followUpDate} disabled InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Tentative Work Start Date" type="date" fullWidth value={formData.workStartDate} disabled InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Tentative Work End Date" type="date" fullWidth value={formData.workEndDate} disabled InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Reason For HOLD" fullWidth multiline rows={2} value={formData.reasonForHold} disabled />
            </Grid>
          </Grid>

          <Box mt={3} display="flex" justifyContent="space-between">
            <Button
              variant="contained"
              color="primary"
              style={{ width: "48%", borderRadius: 12 }}
              onClick={() => setApproveDialogOpen(true)}
              disabled={!formData.initiationIsHold}
            >
              Approve HOLD
            </Button>

            <Button
              variant="contained"
              color="secondary"
              style={{ width: "48%", borderRadius: 12 }}
              onClick={() => setRejectDialogOpen(true)}
              disabled={!formData.initiationIsHold}
            >
              Reject HOLD
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* ===== APPROVE DIALOG ===== */}
      <Dialog
        open={approveDialogOpen}
        onClose={() => setApproveDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle style={{ fontWeight: 600 }}>
          Approve HOLD Request
        </DialogTitle>

        <DialogContent dividers>
          <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary">
              Are you sure you want to approve the HOLD request? Please provide
            </Typography>
          </Box>

          <TextField
            label="When do you want to resume?"
            type="date"
            fullWidth
            variant="outlined"
            margin="normal"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              min: new Date().toISOString().split("T")[0],
            }}
            value={formData.customerResumeDate}
            onChange={(e) =>
              handleChange("customerResumeDate", e.target.value)
            }
            // helperText="Select a future resume date"
          />

          <TextField
            label="Customer Remarks"
            fullWidth
            variant="outlined"
            multiline
            rows={4}
            margin="normal"
            value={formData.customerRemarks}
            onChange={(e) =>
              handleChange("customerRemarks", e.target.value)
            }
            // helperText="Add remarks for approving the HOLD"
          />
        </DialogContent>

        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setApproveDialogOpen(false)}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={!isApproveSubmitEnabled}
            onClick={() => initiationBomTableOps("Hold Approved")}
            style={{ minWidth: 120 }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* ===== REJECT DIALOG ===== */}
      <Dialog
        open={rejectDialogOpen}
        onClose={() => setRejectDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle style={{ fontWeight: 600 }}>
          Reject HOLD Request
        </DialogTitle>

        <DialogContent dividers>
          <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary">
              Are you sure you want to reject the HOLD request? Please provide
            </Typography>
          </Box>

          <TextField
            label="Reject Reason"
            fullWidth
            variant="outlined"
            multiline
            rows={4}
            margin="normal"
            value={formData.rejectReason}
            onChange={(e) =>
              handleChange("rejectReason", e.target.value)
            }
            // helperText="Please mention the reason for rejecting the HOLD request"
          />
        </DialogContent>

        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setRejectDialogOpen(false)}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            color="secondary"
            variant="contained"
            disabled={!isRejectSubmitEnabled}
            onClick={() => initiationBomTableOps("Hold Rejected")}
            style={{ minWidth: 120 }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default connect(null, {
  setCustomerDetails,
  setSnackInfo,
  setLoading,
})(CustomerHoldReqPage);